<template>
  <Modal
    mayCancel="true"
    modalType="ImageLibrary"
    v-on:cancel="onCancel"
    class="m-auto-width"
    :anchorRect="anchorRect"
    anchorStyle="leftAuto"
  >
    <ImageLibrary :onSelectImage="handleSelectImage"></ImageLibrary>
  </Modal>
</template>

<script lang="ts">
import Vector from "victor";
import { Component } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import ImageLibrary from "@/components/ImageLibrary.vue";
import { ModalType } from "@/store/ModalType";
import { LIBRARIES, Library } from "@/library";
import Rect from "@/wbcontroller/types/Rect";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal, ImageLibrary } })
export default class ImageLibraryModal extends WBComponent {
  beforeMount() {
    ModalMutations.updateModalAnchor(this.$store.commit, {
      modalType: ModalType.ImageLibrary,
      selector: ".js-ToolButton.m-imageLibrary",
    });
  }

  get anchorRect(): Rect | undefined {
    return this.state.modal.modalAnchors[ModalType.ImageLibrary];
  }

  get LIBRARIES(): [Library] {
    return LIBRARIES;
  }

  onCancel() {
    ModalMutations.closeModals(this.$store.commit);
  }

  handleSelectImage(image: { url: string; size: Vector }) {
    ModalMutations.closeModals(this.$store.commit);
    this.wbcontroller?.beginPlacingImageFromLibrary(image);
  }
}
</script>

<style scoped lang="scss"></style>
